var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b',[_vm._v(_vm._s(_vm.zonesMap.get(_vm.item.loadingZone).name)+" ")]),_vm._v(" >>> "),_c('b',[_vm._v(_vm._s(_vm.zonesMap.get(_vm.item.unloadingZone).name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }